module.exports = __webpack_public_path__ + "img/bg_order_failed.b7a13560.png";